// extracted by mini-css-extract-plugin
module.exports = {"spendingLockContainer":"SpendingLock_spendingLockContainer__cjjDW","spendingLockOptionsContainer":"SpendingLock_spendingLockOptionsContainer__2hVl1"};